import * as React from "react";
const SvgFiRrHandWave = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-wave_svg__a)">
      <path
        fill="#062147"
        d="M13.04.72c.156-.53.713-.834 1.241-.68 1.843.54 3.114 1.81 3.677 3.671a1 1 0 0 1-1.915.58c-.373-1.235-1.11-1.975-2.323-2.33a1 1 0 0 1-.679-1.24zM24 7.983v6.17a9.06 9.06 0 0 1-2.658 6.386l-.815.81c-1.72 1.71-4.104 2.65-6.526 2.65-2.454-.02-4.725-1.006-6.436-2.766L.842 14.316c-.964-.965-1.119-2.506-.35-3.576.238-.33.541-.599.885-.793l-.344-.344C.058 8.628-.097 7.086.674 6.017A2.75 2.75 0 0 1 2.08 5c-.127-.71.005-1.45.434-2.047A2.74 2.74 0 0 1 4.52 1.815a2.73 2.73 0 0 1 1.942.622c.051-.094.1-.19.162-.278a2.74 2.74 0 0 1 2.005-1.137 2.72 2.72 0 0 1 2.154.792L18 9.032v-.939c0-1.517 1.076-2.835 2.504-3.067a3.02 3.02 0 0 1 2.44.674A3 3 0 0 1 24 7.986zm-2 0a1 1 0 0 0-.353-.762 1.01 1.01 0 0 0-.823-.224c-.462.075-.825.555-.825 1.093v3.354a1.002 1.002 0 0 1-1.707.707L9.368 3.227a.733.733 0 0 0-1.122.1c-.2.278-.134.72.15 1.003l5.051 5.051a.999.999 0 1 1-1.414 1.414L5.258 4.021a.733.733 0 0 0-1.122.1c-.2.278-.134.718.15 1.003l6.71 6.71a.999.999 0 1 1-1.414 1.414L3.42 7.085a.735.735 0 0 0-1.122.101c-.2.278-.134.718.15 1.003l6.097 6.097A.999.999 0 1 1 7.13 15.7l-3.89-3.89a.74.74 0 0 0-1.124.1c-.2.277-.134.718.151 1.002L9 19.842a7.07 7.07 0 0 0 5.041 2.156 7.18 7.18 0 0 0 5.078-2.066l.815-.81A7.05 7.05 0 0 0 22 14.155zM4.281 21.04c-1.212-.355-1.95-1.095-2.323-2.329a1 1 0 1 0-1.915.579c.562 1.862 1.834 3.131 3.677 3.671q.141.04.281.041a1.002 1.002 0 0 0 .28-1.962"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-wave_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandWave;
